import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {CoreComponent} from "../core-component/core.component";
import {FormGroup} from "@angular/forms";
import {EuOtpCodeLoginType} from "../../interfaces/core.types";
import {AuthService} from "../../service/auth.service";

@Component({
  selector: 'login-otp-request',
  templateUrl: './login-otp-request.component.html',
  styleUrls: ['./login-otp-request.component.css']
})
export class LoginOtpRequestComponent extends CoreComponent implements OnInit, OnDestroy {

  @Input() formGroup!: FormGroup | undefined;
  @Output() onStepComplete = new EventEmitter<number>;
  @Output() onSelectOption = new EventEmitter<EuOtpCodeLoginType>;

  visible: boolean = false;

  selectedOption: EuOtpCodeLoginType = EuOtpCodeLoginType.EMAIL;
  // otpOptions = [
  //   {type: 'email', label: 'Per E-Mail'},
  //   {type: 'sms', label: 'Per SMS an Telefonnummer'}
  // ];

  otpOptions = [
    { type: EuOtpCodeLoginType.EMAIL, label: 'Per E-Mail' },
    { type: EuOtpCodeLoginType.MOBILE_PHONE, label: 'Per SMS an deine Handynummer' }
  ];

  constructor(
    protected authService: AuthService,
    protected router: Router) {
    super();
  }

  override ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }

  handleStepComplete(selectedOption : EuOtpCodeLoginType) {

    this.onSelectOption.emit(selectedOption);

    if(selectedOption == EuOtpCodeLoginType.EMAIL) {
      this.onStepComplete.emit(1);
    }
    else {
      this.onStepComplete.emit(2);
    }
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }
  navigateBack(){
    this.router.navigate(['/']);
  }
}
